import {SET_PENDING_TRANSACTIONS,NEW_EVENT,SET_LOADING} from '../../types';
import { fromUnit, toUnit} from '../../../config';
import { sendTx, BASE_BLOCK_SIZE  } from '../../helpers/bc';
import { getNRGBalance, getSpendableOutpoints } from '../../passport/get';
import { getWallet } from '../../helpers/wallet';
import {Decimal} from 'decimal.js';

import {
  createMakerOrderTransaction
} from 'bc-sdk/dist/transaction'

export function placeMakerOrder({password},done){
  return async function(dispatch,getState) {
    try {
      dispatch({type:SET_LOADING,payload:'order'})
      Decimal.set({ precision: 18})
      Decimal.set({ toExpNeg: -18 })
      const state = getState()
      let tradeAddresses = state.passport.tradeAddresses
      let address = tradeAddresses.nrg;
      let { privateKey: bcPrivateKeyHex} = getWallet(getState, address, 'nrg', password)

      let collateral =  state.ui_marketplace.makerCollateral
      let {denomination,asset,type} = state.ui_marketplace.market;

      let sendsFromChain = state.ui_marketplace.orderType === 'BUY' ? denomination : asset;
      let receivesToChain = state.ui_marketplace.orderType === 'BUY' ? asset : denomination;

      let sendsFromAddress = tradeAddresses[sendsFromChain.toLowerCase()]
      let receivesToAddress = tradeAddresses[receivesToChain.toLowerCase()]

      let receivesUnit = state.ui_marketplace.orderType === 'BUY' ? state.ui_marketplace.makerAmount : new Decimal(state.ui_marketplace.makerAmount).mul(new Decimal(state.ui_marketplace.price)).toString()
      let sendsUnit = state.ui_marketplace.orderType === 'SELL' ? state.ui_marketplace.makerAmount : new Decimal(state.ui_marketplace.makerAmount).mul(new Decimal(state.ui_marketplace.price)).toString()


      sendsUnit = fromUnit(sendsFromChain.toLowerCase(),Math.floor(toUnit(sendsFromChain.toLowerCase(),sendsUnit)))
      receivesUnit = fromUnit(receivesToChain.toLowerCase(),Math.floor(toUnit(receivesToChain.toLowerCase(),receivesUnit)))


      let recAmount = new Decimal(receivesUnit).toString()
      let sendAmount = new Decimal(sendsUnit).toString()

      if(recAmount == '0' || sendAmount == '0'){
        done(`Price/Amount cannot be 0`);
        dispatch({type:SET_LOADING,payload:false})
        return;
      }

      recAmount = toUnit(receivesToChain.toLowerCase(),recAmount)
      sendAmount = toUnit(sendsFromChain.toLowerCase(),sendAmount)

      if(Math.floor(recAmount) != recAmount){
        done(`Precision for ${receivesToChain.toUpperCase()} is Incorrect`);
        dispatch({type:SET_LOADING,payload:false})
        return;
      }

      if(Math.floor(sendAmount) != sendAmount){
        done(`Precision for ${sendsFromChain.toUpperCase()} is Incorrect`);
        dispatch({type:SET_LOADING,payload:false})
        return;
      }

      let nrgUnit = new Decimal(collateral).div(new Decimal(1000)).toString()

      if(sendsFromChain.toLowerCase() == 'neo'){
        if(new Decimal(sendsUnit).toNumber() != Math.floor(new Decimal(sendsUnit).toNumber())){
          done('NEO cannot be sent in increments of less than 1');
          dispatch({type:SET_LOADING,payload:false})
          return;
        }
        nrgUnit = collateral;
      }

      if(receivesToChain.toLowerCase() == 'neo'){
        if(new Decimal(receivesUnit).toNumber() != Math.floor(new Decimal(receivesUnit).toNumber())){
          done('NEO cannot be sent in increments of less than 1');
          dispatch({type:SET_LOADING,payload:false})
          return;
        }
        nrgUnit = collateral;
      }

      let spendableOutpointsList = state.passport.spendableOutpoints[address];
      if(!spendableOutpointsList || spendableOutpointsList.length === 0){
        await getSpendableOutpoints(dispatch, state)
        spendableOutpointsList = state.passport.spendableOutpoints[address]
      }
      if(!spendableOutpointsList || spendableOutpointsList.length === 0){
        dispatch({type:SET_LOADING,payload:false})
        done('Transaction exceeds balance.')
        return
      }

      let tx = null;

      //NRG ORDER
      if(sendsFromChain.toLowerCase() == 'nrg') {
        if(receivesToChain.toLowerCase() === 'neo') nrgUnit = sendsUnit.toString();
        else nrgUnit = new Decimal(sendsUnit.toString()).div(new Decimal(1000)).toString()
        tx = createMakerOrderTransaction(
          spendableOutpointsList,
          0, state.settings.settings.shiftTaker,
          state.settings.settings.deposit, state.settings.settings.settlement,
          sendsFromChain.toLowerCase(), receivesToChain.toLowerCase(),
          sendsFromAddress.toString(), receivesToAddress.toString(),
          sendsUnit.toString(), receivesUnit.toString(),
          address.toString(), bcPrivateKeyHex.toString(),
          sendsUnit.toString(), nrgUnit.toString(),collateral.toString(), '0', true
        )
      }
      //NORMAL ORDER
      else {
        tx = createMakerOrderTransaction(
          spendableOutpointsList,
          state.settings.settings.shiftMaker, state.settings.settings.shiftTaker,
          state.settings.settings.deposit, state.settings.settings.settlement,
          sendsFromChain.toString(), receivesToChain.toString(),
          sendsFromAddress.toString(), receivesToAddress.toString(),
          sendsUnit.toString(), receivesUnit.toString(),
          address.toString(), bcPrivateKeyHex.toString(),
          collateral.toString(), nrgUnit.toString(),'', '0', true
        )
      }

      const txSize = tx.serializeBinary().length

      let maxSize = Math.floor(BASE_BLOCK_SIZE * 2 / 3)
      if (maxSize <= txSize) {
        dispatch({type:SET_LOADING,payload:false})
        done('Please Consolidate Your UTXOs')
        return
      }

      let data = await sendTx(state.settings.settings, tx)
      if(data.txHash){
        // getNRGBalance(dispatch,getState())
        await getSpendableOutpoints(dispatch,getState())

        dispatch({
          type:SET_PENDING_TRANSACTIONS,
          payload: {hash:data.txHash,type:"Trade Order (Maker)",amount:collateral.toString(),chain:"NRG",from:address,to:'Tx Pending Pool'}
        });

        if(getState().settings.settings.autoTrader){
          dispatch({
            type:NEW_EVENT,
            payload: {isMaker:true,txHash:data.txHash,to:'TBD',from:sendsFromAddress.toString(),chain:sendsFromChain.toUpperCase(),amount:sendsUnit,password}
          })
        }
        dispatch({type:SET_LOADING,payload:false})
        done(null,data);
      }
      else {
        dispatch({type:SET_LOADING,payload:false})
        done('Could not place order')
      }
      return
    }
    catch(err){
      console.log({err})
      dispatch({type:SET_LOADING,payload:false})
      if(err.toString().includes('val.to') || err.toString().includes('t.to')) done('Transaction exceeds balance.')
      else if(err.toString().includes('Not enough balance')) done('Not enough NRG to Place Order')
      else done(err)
    }
  }
}
